<template>
  <div
    class="search-filter-page"
    :style="[searchFilterColorStyles, paddingStyle]"
  >
    <main class="search-filter-main-wrapper">
      <div class="search-filter-filter-pane">
        <SkeletonLoader height="60px" />
        <div class="search-filter-filters">
          <SkeletonLoader />
        </div>
      </div>
      <ResultsLoading :job-search-global="jobSearchGlobal" />
    </main>
  </div>
</template>

<script>
import jobSearchGlobal from "../../../globalSettingProps/jobSearchDefaultGlobalProp.js";
import ResultsLoading from "../ResultsLoading/ResultsLoading.vue";
import { searchAndFilterComputed } from "../mixins/searchAndFilter.js";
import SkeletonLoader from "../../SkeletonLoader/SkeletonLoader.vue";

export default {
  name: "SearchLoadingPlaceholder",
  components: { SkeletonLoader, ResultsLoading },
  mixins: [searchAndFilterComputed],
  props: {
    jobSearchGlobal: {
      type: Object,
      default() {
        return jobSearchGlobal;
      },
    },
    usedInModule: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    paddingStyle() {
      if (this.usedInModule) {
        const { paddings } = this.jobSearchGlobal.config.general;

        return {
          paddingTop: paddings.top
            ? "var(--cr-module-padding-large)"
            : "var(--cr-module-padding-small)",
          paddingBottom: paddings.bottom
            ? "var(--cr-module-padding-large)"
            : "var(--cr-module-padding-small)",
        };
      }
    },
  },
};
</script>
